<template>
  <div ref="scrollElement" class="page-news wh-full overflow-auto relative">
    <Resource
      :src="getFeUrl('/youyan-platform/png/top-bg-slider.png')"
      :transform-resource="transformImage"
      class="absolute top-0 left-0 w-full"
    ></Resource>
    <div class="w-[1200px] mx-auto mt-9">
      <a-breadcrumb class="relative" :separator="separator">
        <a-breadcrumb-item>
          <nuxt-link :to="{ name: PageKey.HOME }">
            {{ $t('shou-ye') }}
          </nuxt-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item> {{ $t('chan-pin-liang-dian') }} </a-breadcrumb-item>
      </a-breadcrumb>

      <article class="page-news-content relative mx-auto pb-[100px] mt-8">
        <section class="mod-highlight">
          <h3 class="m-0 font-semibold text-[18px] text-font-1">
            {{ $t('gong-neng-liang-dian') }}
          </h3>
          <Highlight mode="grid" class="top-4" />
        </section>
        <section class="mod-change-video mt-[46px]">
          <UpdateVideo />
        </section>
      </article>
    </div>
  </div>
</template>

<script lang="ts" setup>
import UpdateVideo from './UpdateVideo.vue';
import Highlight from '~/components/content/highlight/index.vue';
import { PageKey } from '~/constants/page';

const separator = h('iconpark-icon', { name: 'breadcrumb-separator', size: 10 });
</script>
